<p>
  rerouting-support-doc works!
</p>
